<template>
  <div class="chuKuZuoyeWarp">
    <div class="chuKuZuoyeWarp-body">
      <div ref="searchBox">
        <div class="detailsTitle">
          <h4>{{ title }}</h4>
        </div>
        <!-- 查询条件 -->
        <div class="inpBox">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="签订日期:">
              <el-date-picker
                v-model="formInline.ruKuStartTime"
                size="mini"
                style="width: 195px"
                placeholder="选择日期"
                type="date"
                value-format="yyyy-MM-dd"
              ></el-date-picker
              >&nbsp; &nbsp;- &nbsp;&nbsp;&nbsp;
              <el-date-picker
                v-model="formInline.ruKuEndTime"
                size="mini"
                style="width: 195px"
                placeholder="选择日期"
                type="date"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="托运方:">
              <el-input
                v-model="formInline.tuoyun"
                size="mini"
                placeholder="请输入托运方"
              ></el-input>
            </el-form-item>
            <el-form-item label="发布部门:">
              <el-input
                size="mini"
                placeholder="请输入发布部门"
                v-model="formInline.createOrgName"
              ></el-input>
            </el-form-item>
            <el-form-item label="发布人:">
              <el-input
                size="mini"
                placeholder="请输入发布人"
                v-model="formInline.createUser"
              ></el-input>
            </el-form-item>
          </el-form>
          <div style="margin-left: 20px">
            <el-button
              type="primary"
              size="mini"
              @click="chaxun"
              btnCode="00FP004B001"
              v-if="btnFlg[0]"
              >查询</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="chongZhi"
              btnCode="00FP004B002"
              v-if="btnFlg[1]"
              >重置</el-button
            >
            <el-button
              type="primary"
              size="mini"
              btnCode="00FP004B002"
              @click="batchDownload"
              >批量下载</el-button
            >
          </div>
        </div>
      </div>
      <!--表格1-->
      <div class="chuKuZuoyeWarp-body-table" :style="{ height: h }">
        <el-table
          border
          height="100%"
          size="mini"
          ref="tabref"
          :data="cangchuTableData"
          style="width: 100%"
          class="elTab"
          highlight-current-row
          @row-click="dianjixuanzhong"
          @selection-change="handleSelectionChange"
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="60"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <div>
                <!-- <el-button
                  type="text"
                  size="mini"
                  @click="seeClick(scope.row, 'download')"
                  btnCode="00FP004B003"
                  v-if="btnFlg[2]"
                  >合同详情</el-button
                > -->
                <el-button
                  type="text"
                  size="mini"
                  @click="seeClick(scope.row,'look')"
                  btnCode="00FP004B003"
                  v-if="btnFlg[2]"
                  >查看</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  btnCode="00FP004B003"
                  v-if="btnFlg[2]"
                  @click="seeClick(scope.row,'download')"
                  >下载</el-button
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="contractNo"
            label="合同编号"
            align="center"
            min-width="200"
            :formatter="emptyFn"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="businessNo"
            label="订单号"
            align="center"
            min-width="200"
            :formatter="emptyFn"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="partyBName"
            label="承运方"
            align="center"
            :formatter="emptyFn"
            width="270"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="partyAName"
            label="托运方"
            align="center"
            :formatter="emptyFn"
            width="270"
          ></el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="signDate"
            label="签订日期"
            align="center"
            :formatter="emptyFn"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="createOrgName"
            label="发布部门"
            align="center"
            :formatter="emptyFn"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="createUser"
            label="发布人"
            align="center"
            :formatter="emptyFn"
          ></el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pags" style="text-align: left">
        <el-pagination
          background
          @current-change="handleCurrentChangeA"
          :current-page="current"
          :page-size="pagesize"
          :page-sizes="[10, 20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChangeA"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 订单详情弹窗 -->
    <div>
      <el-dialog
        :title="this.titleDetail"
        :visible.sync="detailsMark"
        :close-on-click-modal="false"
        width="80%"
        center
        :before-close="handleClose"
      >
        <!-- ==================================================================================订单 -->
        <div v-loading="loading">
          <!-- 订单 -->
          <el-form
            :inline="true"
            ref="goodform"
            enctype="multipart/form-data"
            :model="goodform"
            class="demo-form-inline"
            label-width="180px"
            size="mini"
            v-if="this.num == '0'"
          >
            <div class="addressBoxTitle">
              <div>订单号 ：{{ goodform.orderNo }}</div>
            </div>

            <hr />
            <div class="addressBox">
              <h4 class="title">
                <span>
                  <i class="fa fa-cubes iconFont" aria-hidden="true"></i
                  >货物信息
                </span>
              </h4>
              <div>
                <el-form-item
                  label="货物类型 :"
                  class="jiage"
                  prop="productType"
                >
                  <span>{{ goodform.productTypeName }}</span>
                </el-form-item>
                <el-form-item label="调度量 :" class="jiage" prop="weight">
                  <span>{{ goodform.weight }}</span>
                  <span class>{{ goodform.unitMeasurement }}</span>
                </el-form-item>
                <el-form-item label="装车量 :" class="jiage" prop="num">
                  <span>{{ goodform.loadingWeight }}</span>
                  <span class>{{ goodform.unitMeasurement }}</span>
                </el-form-item>
                <el-form-item label="卸车量 :" class="jiage" prop="num">
                  <span>{{ goodform.unloadingWeight }}</span>
                  <span class>{{ goodform.unitMeasurement }}</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item
                  label="计价方式 :"
                  class="jiage"
                  prop="pricingMethod"
                >
                  <span>{{ goodform.pricingMethod }}</span>
                  <span class></span>
                </el-form-item>
                <el-form-item label="单价 :" class="jiage" prop="unitPrice">
                  <span v-if="goodform.pricingMethod == '包干'">-</span>
                  <span v-else-if="goodform.pricingMethod !== '包干'">
                    {{ goodform.unitPrice }}
                    <span class>元</span>
                    <span>
                      <span v-if="goodform.unitMeasurement">/</span>
                      {{ goodform.unitMeasurement }}
                    </span>
                  </span>
                </el-form-item>
                <el-form-item label="运费 :" class="jiage" prop="fatePrice">
                  <span style="color: #f56c6c">{{ goodform.fatePrice }}</span>
                  <span class>元</span>
                </el-form-item>
                <el-form-item label="服务费 :" class="jiage" prop="taxation">
                  <span style="color: #f56c6c">{{ goodform.taxation }}</span>
                  <span class>元</span>
                </el-form-item>
                <el-form-item label="运费合计 :" class="jiage" prop="fatePrice">
                  <span style="color: #f56c6c">{{ sun }}</span>
                  <span class>元</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item
                  label="发单时间 :"
                  class="jiage"
                  prop="transportStartOperateDate"
                >
                  <span>{{
                    goodform.transportStartOperateDate | dateFormat
                  }}</span>
                </el-form-item>
                <el-form-item
                  label="送达时间 :"
                  class="jiage"
                  prop="transportEndOperateDate"
                >
                  <span>{{
                    goodform.transportEndOperateDate | dateFormat
                  }}</span>
                  <span class></span>
                </el-form-item>
              </div>
            </div>
            <hr />
            <div class="addressBox">
              <h4 class="title">
                <span>
                  <i class="fa fa-envelope iconFont" aria-hidden="true"></i
                  >货运信息
                </span>
              </h4>
              <div class="box1">
                <div class="item">
                  <div class="box1T">
                    <i style="color: #fc9727" class="el-icon-location"></i>
                    发货地址 ：
                    <span style="color: #fc9727">{{
                      goodform.deliverCompany
                    }}</span>
                  </div>
                  <div class="box1B">
                    <span
                      >{{
                        goodform.deliverPerson
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span
                      >{{
                        goodform.deliverPhone
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span>{{ goodform.deliverAddress }}</span>
                  </div>
                </div>
                <div class="item">
                  <div class="box1T">
                    <i style="color: #1ea827" class="el-icon-location"></i>
                    收货地址 ：
                    <span style="color: #1ea827">{{
                      goodform.receivingCompany
                    }}</span>
                  </div>
                  <div class="box1B">
                    <span
                      >{{
                        goodform.receivingPerson
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span
                      >{{
                        goodform.receivingPhone
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span>{{ goodform.receivingAddress }}</span>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="addressBox" v-if="this.goodform.sWayList">
              <h4 class="title">
                <span>
                  <i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i
                  >运单信息
                </span>
              </h4>
              <div>
                <el-table
                  height="300px"
                  size="mini"
                  ref="tabref"
                  :data="this.goodform.sWayList"
                  style="width: 100%"
                  class="elTab"
                  border
                  :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
                >
                  <el-table-column
                    prop="wayNo"
                    label="运单号"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="dirverName"
                    label="司机姓名"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="vhcNo"
                    label="车牌号"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="weight"
                    label="调度量"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="loadingWeight"
                    label="装车量"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="unloadingWeight"
                    label="卸车量"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column label="凭证" align="center">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="mini"
                        @click="QualityClick(scope.row)"
                        >查看</el-button
                      >
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="" label="货物详情" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" size="mini" @click="QualityClick2(scope.row)">查看</el-button>
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    prop="receivingTime"
                    label="接单时间"
                    align="center"
                    :formatter="dateFormat"
                  ></el-table-column>
                  <el-table-column
                    prop="outTime"
                    label="装车时间"
                    align="center"
                    :formatter="dateFormat"
                  ></el-table-column>
                  <el-table-column
                    prop="arrivalTime"
                    label="到货时间"
                    align="center"
                    :formatter="dateFormat"
                  ></el-table-column>
                  <el-table-column
                    prop="signingTime"
                    label="签收时间"
                    align="center"
                    :formatter="dateFormat"
                  ></el-table-column>
                </el-table>
              </div>
            </div>

            <hr />
          </el-form>
          <!-- 运单 -->
          <el-form
            :inline="true"
            ref="goodform"
            enctype="multipart/form-data"
            :model="goodform"
            class="demo-form-inline"
            label-width="180px"
            size="mini"
            v-else-if="this.num == '1'"
          >
            <div class="addressBoxTitle">
              <div>运单号 ：{{ goodform.wayNo }}</div>
              <div>所属订单 ：{{ goodform.orderNo }}</div>
            </div>
            <hr />
            <div class="addressBox">
              <h4 class="title">
                <span>
                  <i class="fa fa-cubes iconFont" aria-hidden="true"></i
                  >货物信息
                </span>
              </h4>
              <div>
                <el-form-item
                  label="货物类型 :"
                  class="jiage"
                  prop="productType"
                >
                  <span>{{ goodform.productTypeName }}</span>
                </el-form-item>
                <el-form-item label="调度量 :" class="jiage" prop="weight">
                  <span>{{ goodform.weight }}</span>
                  <span class>{{ goodform.unitMeasurement }}</span>
                </el-form-item>
                <el-form-item label="装车量 :" class="jiage" prop="num">
                  <span>{{ goodform.loadingWeight }}</span>
                  <span class>{{ goodform.unitMeasurement }}</span>
                </el-form-item>
                <el-form-item label="卸车量 :" class="jiage" prop="num">
                  <span>{{ goodform.unloadingWeight }}</span>
                  <span class>{{ goodform.unitMeasurement }}</span>
                </el-form-item>
              </div>
              <div>
                <!-- <el-form-item label="货物件数 :" class="jiage" prop="productType" v-if="this.num=='0'">
                  <span>{{goodform.num}}</span>
                  <span class>件</span>
                </el-form-item> -->

                <el-form-item
                  label="计价方式 :"
                  class="jiage"
                  prop="valuationType"
                >
                  <span>{{ goodform.valuationType }}</span>
                  <span class></span>
                </el-form-item>

                <el-form-item label="单价 :" class="jiage" prop="fatePrice">
                  <span v-if="goodform.valuationType == '按单'">-</span>
                  <span v-else-if="goodform.valuationType !== '按单'">
                    {{ goodform.unitPrice }}
                    <span class>元</span>
                    <span>
                      <span v-if="goodform.unitMeasurement">/</span>
                      {{ goodform.unitMeasurement }}
                    </span>
                  </span>
                </el-form-item>
                <el-form-item
                  label="运费 :"
                  class="jiage"
                  prop="actualFatePrice"
                >
                  <span style="color: #f56c6c">{{
                    goodform.actualFatePrice
                  }}</span>
                  <span class>元</span>
                </el-form-item>
              </div>

              <div>
                <el-form-item
                  label="接单时间 :"
                  class="jiage"
                  prop="receivingTime"
                >
                  <span>{{ goodform.receivingTime | dateFormat }}</span>
                </el-form-item>
                <el-form-item
                  label="送达时间 :"
                  class="jiage"
                  prop="arrivalTime"
                >
                  <span>{{ goodform.arrivalTime | dateFormat }}</span>
                  <span class></span>
                </el-form-item>
              </div>
            </div>
            <hr />
            <div class="addressBox">
              <h4 class="title">
                <span>
                  <i class="fa fa-envelope iconFont" aria-hidden="true"></i
                  >货运信息
                </span>
              </h4>
              <div class="box1">
                <div class="item">
                  <div class="box1T">
                    <i style="color: #fc9727" class="el-icon-location"></i>
                    装货地址 ：
                    <span style="color: #fc9727">{{
                      goodform.deliverCompany
                    }}</span>
                  </div>
                  <div class="box1B">
                    <span
                      >{{
                        goodform.deliverPerson
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span
                      >{{
                        goodform.deliverPhone
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span>{{ goodform.deliverAddress }}</span>
                  </div>
                </div>
                <div class="item">
                  <div class="box1T">
                    <i style="color: #1ea827" class="el-icon-location"></i>
                    卸货地址 ：
                    <span style="color: #1ea827">{{
                      goodform.receivingCompany
                    }}</span>
                  </div>
                  <div class="box1B">
                    <span
                      >{{
                        goodform.receivingPerson
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span
                      >{{
                        goodform.receivingPhone
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span>{{ goodform.receivingAddress }}</span>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div
              class="addressBox"
              v-if="this.num == '1' && this.goodform.goodList"
            >
              <h4 class="title">
                <span>
                  <i class="fa fa-bars iconFont" aria-hidden="true"></i>货物详情
                </span>
              </h4>
              <div>
                <el-table
                  height="200px"
                  size="mini"
                  ref="tabref"
                  :data="this.goodform.goodList"
                  style="width:100%"
                  class="elTab"
                  :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
                >
                  <el-table-column
                    type="index"
                    align="center"
                    label="序号"
                    width="60"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="cargoBarcode"
                    label="捆包号"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="productName"
                    label="品名"
                    :formatter="emptyFn"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="brand"
                    label="牌号"
                    :formatter="emptyFn"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="specification"
                    label="规格"
                    :formatter="emptyFn"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="model"
                    label="材质"
                    :formatter="emptyFn"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="weight"
                    label="重量（吨）"
                    :formatter="emptyFn"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="position"
                    label="库位"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                </el-table>
              </div>
              <hr />
            </div>
            <div class="addressBoxImg addressBox" v-if="this.num == '1'">
              <h4 class="title">
                <span>
                  <i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i
                  >装车凭证
                </span>
              </h4>
              <div>
                <ul class="ul">
                  <!-- 装车凭证 -->
                  <li v-for="(item, index) in srcList" :key="index">
                    <el-image
                      fit="cover"
                      style="width: 150px; height: 150px"
                      :src="item"
                      :preview-src-list="getSrcList(index)"
                    >
                    </el-image>
                  </li>
                </ul>
                <!-- <ul class="ul2">
                  <li>装车凭证</li>
                  <li>卸车凭证</li>
                </ul> -->
              </div>
            </div>
            <hr />
            <div class="addressBoxImg addressBox" v-if="this.num == '1'">
              <h4 class="title">
                <span>
                  <i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i
                  >卸车凭证
                </span>
              </h4>
              <div>
                <ul class="ul">
                  <!-- 装卸车凭证 -->
                  <li v-for="(item, ix) in srcList2" :key="ix">
                    <el-image
                      fit="cover"
                      style="width: 150px; height: 150px"
                      :src="item"
                      :preview-src-list="getSrcList2(ix)"
                    >
                    </el-image>
                  </li>
                </ul>
                <!-- <ul class="ul2">
                  <li>装车凭证</li>
                  <li>卸车凭证</li>
                </ul> -->
              </div>
            </div>
          </el-form>
        </div>

        <!-- ----------------------------------------------------------------------------------运单 -->
        <div style="width: 170px; margin: 15px auto">
          <!-- <el-button type="primary" @click="remarkOk">确定</el-button> -->
          <el-button type="primary" @click="quxiao">关闭</el-button>
        </div>
      </el-dialog>
      <!-- 查看凭证弹框 -->
      <lookVoucher
        :row-data="row"
        v-if="zujianFlag"
        @destroy="destroy"
      ></lookVoucher>
      <!-- 查看货物详情 -->
      <lookGoodsDetails
        :row-data-list="rows"
        v-if="zujianFlag2"
        @detailDestroy="detailDestroy"
      ></lookGoodsDetails>
    </div>

    <el-dialog title="提示" :visible.sync="pdfVisible" @close="pdfClose">
      <!-- <pdf :src="pdfUrl" :page="currentPage" @num-pages="numPages = $event"></pdf>
      <div class="pagination ">
        <button @click="prevPage">上一页</button>
        <button @click="nextPage">下一页</button>
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { emptyFn } from '@/utils/util'
import lookVoucher from '@/components/networkFreight/lookVoucher.vue'
import lookGoodsDetails from '@/components/lookGoodsDetails.vue'
import {
  findContractBypList,
  getContractPdfForBusinessNo,
  getbusinessNo,
  getListWayByOrderNo,
  getContractPdfForBusinessNoCopy
} from '@/api/common-signature'
import { fileDownAll } from '@/utils/fileDownAll.js'
export default {
  name: 'carriage',
  components: {
    lookGoodsDetails,
    lookVoucher
  },
  data () {
    return {
      now: '',
      sun: 0,
      emptyFn: emptyFn,

      // ----订单详情
      srcList: [],
      srcList2: [],
      loading: false,
      goodform: {},
      detailsMark: false,
      num: 0,
      title: '承运合同',
      titleDetail: '订单详情',
      h: '500px',
      xuanzhongArr: [],
      cangchuTableData: [],
      // 查询条件
      formInline: {
        number: '',
        tuoyun: '',
        ruKuStartTime: '',
        ruKuEndTime: '',
        createOrgName: '',
        createUser: ''
      },
      pagesize: 20,
      current: 1,
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['00FP004B001', '00FP004B002', '00FP004B003'],
      zujianFlag: false,
      zujianFlag2: false, // 货物详情
      loadingImgs: [],
      unloadImgs: [],
      multipleSelection: [],
      pdfUrl: '',
      currentPage: 1,
      numPages: 0,
      pdfVisible: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/carriage')
    this.findContractBypListS()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 100 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
      this.num = 0
    },
    // 点击合同详情进入-pdf显示页面
    seeClick (row, type) {
      if (type == 'look') {
        getContractPdfForBusinessNoCopy({
          flowId: row.flowId,
          source: row.source
        }).then(res => {
          if (res) {
            let tempwindow = window.open('_blank')
            tempwindow.location = res
          } else {
            this.$alert('暂无生成合同', '系统提示')
          }
        }).catch((err) => {
          DonMessage.error(err.message)
        })
      } else {
        getContractPdfForBusinessNo({
          flowId: row.flowId,
          source: row.source
        })
          .then((res) => {
            if (res) {
              var tempwindow = window.open('_blank') // 先打开页面
              tempwindow.location = res // 后更改页面地址
            } else {
              this.$alert('暂无生成合同', '系统提示')
            }
          })
          .catch((err) => {
            DonMessage.error(err.message)
          })
      }
    },
    pdfClose () {
      this.pdfVisible = false
      this.pdfUrl = ''
      this.currentPage = 1
      this.numPages = 0
    },
    prevPage () {
      if (this.currentPage > 1) this.currentPage--
    },
    nextPage () {
      if (this.currentPage < this.numPages) this.currentPage++
    },
    // 点击订单号进入单号页面
    seeClickNO (row) {
      this.detailsMark = true
      // this.num = 0
      this.loading = true
      this.goodform = {}
      this.titleDetail = '订单详情'

      // 1,2--订单  3-运单
      if (row.source == 1 || row.source == 2) {
        // 订单
        getListWayByOrderNo({
          // orderNo: row.businessNo
          orderNo: row.businessNo
        })
          .then((res) => {
            this.loading = false
            this.num = 0
            this.goodform = res
            // 1.单价，2.包干
            if (this.goodform.pricingMethod == 1) {
              this.goodform.pricingMethod = '单价'
            } else {
              this.goodform.pricingMethod = '包干'
            }
            this.sun = '0'
            this.sun = (
              this.goodform.fatePrice + this.goodform.taxation
            ).toFixed(2)
          })
          .catch((err) => {
            this.loading = false
            DonMessage.error(err.message)
          })
      } else if (row.source == 3 || row.source == 4) {
        // 运单
        this.titleDetail = '运单详情'
        getbusinessNo({
          businessNo: row.businessNo
          // businessNo: 'YD00320200827000006'
        })
          .then((res) => {
            this.num = 1
            this.loading = false
            this.goodform = res
            // 获取抢单计价方式：1：单价；2：按单
            if (this.goodform.valuationType == 1) {
              this.goodform.valuationType = '单价'
            } else {
              this.goodform.valuationType = '按单'
            }
            this.loadingImgs = res.loadingImgs
            this.unloadImgs = res.unloadImgs
            this.srcList = []
            this.srcList2 = []
            this.loadingImgs.forEach((item, index) => {
              this.srcList.push(item.fileUrlOSS)
            })
            this.unloadImgs.forEach((item, index) => {
              this.srcList2.push(item.fileUrlOSS)
            })
            // this.srcList.push(this.goodform.imageUrl, this.goodform.imageUrl2)
          })
          .catch((err) => {
            this.loading = false
            DonMessage.error(err.message)
          }) // 调用运单
      }
    },
    // 点击图片放大
    getSrcList (index) {
      return this.srcList.slice(index).concat(this.srcList.slice(0, index))
    },
    // 点击图片放大
    getSrcList2 (ix) {
      return this.srcList2.slice(ix).concat(this.srcList2.slice(0, ix))
    },
    // 主数据
    findContractBypListS () {
      findContractBypList({
        //  pageNo，pageSize，instockDateStart，instockDateEnd，customerName，vehicleNumber，steelMillName，productName，specification，model
        pageNo: this.current, // 页数
        pageSize: this.pagesize, // 条数
        flag: 1,
        shipper: this.formInline.tuoyun, //
        businessNo: this.formInline.number, //
        signDateStart: this.formInline.ruKuStartTime, // 创建开始日 字符型
        signDateEnd: this.formInline.ruKuEndTime, // 创建结束日 字符型
        createOrgName: this.formInline.createOrgName, // 最初创建者-发布人
        createUser: this.formInline.createUser // 最初创建部门名称-发布部门
      })
        .then((res) => {
          this.xuanzhongArr = []
          this.total = res.total
          this.cangchuTableData = res.list
          console.log(res.list)
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 点击关闭弹窗
    handleClose (done) {
      this.detailsMark = false
    },
    quxiao () {
      this.detailsMark = false
    },
    // 查询
    chaxun () {
      this.findContractBypListS()
    },
    // 重置
    chongZhi () {
      this.formInline = {
        ruKuStartTime: '',
        ruKuEndTime: '',
        number: ''
      }
      this.findContractBypListS()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.findContractBypListS()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.findContractBypListS()
    },
    // 凭证
    QualityClick (row) {
      this.row = row
      this.zujianFlag = true
    },
    // 组件销毁
    destroy () {
      this.zujianFlag = false
    },
    // 货物详情
    QualityClick2 (row) {
      this.rows = row
      this.zujianFlag2 = true
    },
    // 组件销毁
    detailDestroy () {
      this.zujianFlag2 = false
    },
    // 勾选选中
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 批量下载
    batchDownload () {
      if (this.multipleSelection.length >= 2) {
        let downloadItems = this.multipleSelection.map((item) => {
          return {
            flowId: item.flowId,
            source: item.source
          }
        })
        fileDownAll(
          this.global.contractName +
            '/api/contractSignature/getContractPdfForBusinessNo/batch',
          downloadItems,
          '合同',
          '.zip'
        )
      } else {
        DonMessage.error('批量下载至少勾选两条数据')
      }
    }
  }
}
// 平台端承运合同取消订单显示，列表增加截止日期
</script>
<style lang="scss" scoped>
.box1B {
  margin-left: 95px !important;

  display: flex !important;
  flex-wrap: wrap !important;

  span {
    // margin-left: 20px !important;
    line-height: 26px !important;
  }
}

.addressBoxTitle {
  div {
    font-size: 22px;
    font-style: 700;
    float: left;
    margin-right: 80px;
  }
}

.addressBoxImg {
  .ul {
    display: flex;
    flex-wrap: wrap;

    li {
      width: 150px;
      height: 150px;
      border-radius: 20px;
      overflow: hidden;
      border: 1px dashed #ccc;
      margin-right: 30px;
      text-align: center;

      img {
        height: 100%;
        width: 100%;
      }
    }
  }

  .ul2 {
    display: flex;
    flex-wrap: wrap;

    li {
      width: 150px;
      margin-right: 30px;

      text-align: center;
    }
  }
}

/deep/.inpBox .el-input__inner {
  width: 195px !important;
}

.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}

.el-form-item {
  margin-left: 10px;
}

.huoQuanChangeWarp-body-title {
  width: 100%;
  height: 35px;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  box-sizing: border-box;

  span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #2f2f2f;
    display: inline;
    line-height: 30px;
    // margin-left: 20px;
  }
}

.chuKuZuoyeWarp {
  width: 100%;
  position: relative;
  height: 100%;

  .pags {
    width: 100%;
    text-align: center;
  }

  // border: solid 1px blue;
  .chuKuZuoyeWarp-body {
    width: 100%;
    position: absolute;

    .chuKuZuoyeWarp-body-queryIpt {
      // margin-top: 5px;
      width: 100%;

      // border: solid 1px;
      display: flex;

      ul {
        flex: 1;
        flex-direction: column;
        display: flex;

        li {
          margin-top: 5px;
          list-style: none;
        }
      }
    }

    .chuKuZuoyeWarp-body-btn {
      margin-top: 5px;
    }

    .chuKuZuoyeWarp-body-table {
      margin-top: 5px;
    }
  }

  /deep/ .el-textarea .el-textarea__inner {
    resize: none;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
